import { combineReducers } from 'redux';
import { loginReducer } from '../login/login.reducer';
import { accountSecurityReducer } from '../details/accountSecurity/accountSecurityReducer';
import { personalInfoReducer } from '../details/personalInfo/personalInfoReducer';
import { rakutenServicesReducer } from '../details/privacyCenter/rakutenServices/legacy/rakutenServices.reducer';
import { privacyCenterReducer } from '../details/privacyCenter/privacyCenter.reducer';
import { rewardsTransactionsHistoryReducer } from '../details/rewardsClub/rewardsTransactionHistory/redux/rewardsTransactionsHistoryReducer';
import clientsReducer from '../clients/clients.reducer';
import { addressesReducer } from '../details/addresses/addressesReducer.ts';
import { cardsReducer } from '../details/paymentMethods/cards/cardsReducer.ts';
import { routesReducer } from '../routes/routesReducer.ts';
import { appReducer, memberReducer } from './app.reducer';
import { notificationsReducer } from './common/notifications/notificationsReducer.tsx';
import { countriesReducer } from '../i18n/countries/countriesReducer';
import { rewardsBalanceReducer } from '../details/rewardsClub/rewardsBalance/redux/rewardsBalanceReducer';
import { cancelMembershipReducer } from '../details/cancelMembership/cancelMembershipReducer';
import { identityVerificationReducer } from '../details/identityVerification/identityVerificationReducer';
import { errorBoxReducer } from './common/errorBox/errorBoxReducer';

const rootReducer = combineReducers({
    app: appReducer,
    member: memberReducer,
    authentication: loginReducer,
    personalInfo: personalInfoReducer,
    accountSecurity: accountSecurityReducer,
    identityVerification: identityVerificationReducer,
    addresses: addressesReducer,
    cards: cardsReducer,
    rakutenServices: rakutenServicesReducer,
    privacyCenter: privacyCenterReducer,
    clients: clientsReducer,
    rewardsTransactionsHistory: rewardsTransactionsHistoryReducer,
    routes: routesReducer,
    notifications: notificationsReducer,
    countries: countriesReducer,
    rewardsBalance: rewardsBalanceReducer,
    cancelMembership: cancelMembershipReducer,
    errorBoxMessage: errorBoxReducer,
});

export default rootReducer;
